import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const DropdownSelection = ({ value, handleSelect, style }) => {
	const handleChange = e => {
		handleSelect(e.target.value);
	};
	return (
		<FormControl style={style}>
			<Select value={value} onChange={handleChange} displayEmpty>
				<MenuItem value='待支付'>待支付</MenuItem>
				<MenuItem value='待发货'>待发货</MenuItem>
				<MenuItem value='待收货'>待收货</MenuItem>
				<MenuItem value='已签收'>已签收</MenuItem>
				<MenuItem value='已关闭'>已关闭</MenuItem>
			</Select>
		</FormControl>
	);
};

DropdownSelection.propTypes = {
	value: PropTypes.string.isRequired,
	handleSelect: PropTypes.func,
};

export default DropdownSelection;
